import React from "react";
import HtmlBlock from "../../../components/htmlBlock/htmlBlock";

const StatBlock = ( { data} ) => {
  let { label, stat : number, subHeading } = data; 
  return(
    <div className="block">
      <span className="block__num">{number}</span>
      <span className="block__label">{label}</span>
      <HtmlBlock tag={'span'} className="block__sub" data={subHeading} />
    </div>
  );
}

export default StatBlock;